import React from 'react';
import dompurify from 'dompurify';
import { FormattedMessage } from 'translations';
import InteractiveInfoBlock from 'app/components/base/InteractiveInfoBlock';
import builder from './builder';

import style from './style.css';

// Constants
const messages = {
  title: { id: 'BOOK_TRIP.PICKUP_INSTRUCTIONS_TITLE' },
  returnTitle: { id: 'BOOK_TRIP.RETURN_PICKUP_INSTRUCTIONS_TITLE' }
};

/**
 * Component to show pickup instructions
 */
export const PickupInstructions = ({
  renderContent,
  numVehicles,
  instructions,
  isReturn,
  showPickupTimeline,
}) => {
  if (!instructions && !showPickupTimeline) return null;

  const iconName = numVehicles > 1
    ? 'mv-pickup-instructions'
    : 'pickup-instructions';

  const titleMessage = isReturn
    ? messages.returnTitle
    : messages.title;

  return (
    <InteractiveInfoBlock
      className={style.container}
      type="blue"
      title={<FormattedMessage {...titleMessage} />}
      text={<div dangerouslySetInnerHTML={{ __html: dompurify.sanitize(instructions) }} />}
      icon={{ family: 'mozio', name: iconName }}
      renderContent={renderContent}
      transparentIcon
      straightIcon
    />
  );
};

// TODO: move to Flow types
// PickupInstructions.propTypes = {
//   numVehicles: PropTypes.number,
//   instructions: PropTypes.string.isRequired,
//   isReturn: PropTypes.bool,
//   showPickupTimeline: PropTypes.bool
// };

export default builder(PickupInstructions);
